<template>
  <transition name="mask-fade">
    <div class="ul-resource-preview__wrapper">
      <div class="ul-resource-preview">
        <!-- 顶栏：文件名、下载（contentSize）、关闭（不展示居中课程名，避免与布局重叠或重复感） -->
        <div class="ul-resource__header">
          <div class="ul-resource__header-inner">
            <span class="ul-resource__title-left" :title="resource.fileName">{{
              resource.fileName
            }}</span>
            <div class="ul-resource__header-actions">
              <button
                v-if="useObsSdkDownload"
                type="button"
                class="preview-action-btn"
                @click="onObsDownloadClick"
              >
                {{ downloadButtonText }}
              </button>
              <a
                v-else-if="canDirectDownload"
                class="preview-action-btn"
                :href="downloadUrl"
                download
                target="_blank"
                rel="noopener"
                >{{ downloadButtonText }}</a
              >
              <button type="button" class="preview-action-btn" @click="hide">
                {{ $t("pages_components_resourcePreview_129") }}
              </button>
            </div>
          </div>
        </div>
        <div class="ul-resource__body">
          <div class="resource-image" v-if="fileType == 'image'">
            <img :src="filePath" />
          </div>
          <div class="resource-document" v-if="fileType == 'document'">
            <div class="wrapper">
              <iframe :src="filePath"></iframe>
            </div>
          </div>
          <div class="resource-video" v-if="fileType == 'video'">
            <div class="video-wrapper">
              <video
                :id="'video-media'"
                width="100%"
                height="100%"
                playsinline
                webkit-playsinline
                class="custom-video"
              >
                <source type="video/mp4" :src="filePath" />
              </video>
            </div>
          </div>
          <div class="resource-audio" v-if="fileType == 'audio'">
            <div class="audio-wrapper">
              <AudioComponent :src="filePath"></AudioComponent>
            </div>
          </div>
          <div
            class="resource-other"
            v-if="
              fileType == 'other' ||
              fileType == 'zip' ||
              fileType == 'flash' ||
              fileType == 'srt'
            "
          >
            <div class="other-wrapper">
              <i class="iconfont" :class="[fileIcon(resource.filePath)]"></i>
              <div>{{ $t("pages_components_resourcePreview_130") }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Obs from "@/plugins/ulearning-obs.js";
import {
  fileType,
  getFullPath,
  fileIcon,
  formatSize,
  setObsConfig,
  extractObsRelativePath,
} from "@/utils/file.js";
import { DOCS_HOST, API_HOST, RESOURCE_SERVER_HOST } from "@/config";
import { getObsDownloadToken } from "@/api/courseApi/virtual.js";
import { mapGetters } from "vuex";
import "mediaelement";
import "mediaelement/build/mediaelementplayer.min.css";
import AudioComponent from "./audio.vue";
export default {
  name: "ResourcePreviewComponent",
  props: {
    resource: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    ...mapGetters({ token: "user/token" }),
    /** downloadToken 的 path：优先 resource.obsDownloadPath，否则从文件 URL 解析 */
    obsDownloadPathKey() {
      const explicit = (this.resource.obsDownloadPath || "").trim();
      if (explicit) {
        return explicit;
      }
      return extractObsRelativePath(this.resource.filePath);
    },
    /** 可解析出 OBS path 时使用凭证下载（避免直连 OBS AccessDenied） */
    useObsSdkDownload() {
      return !!this.obsDownloadPathKey;
    },
    canDirectDownload() {
      return !!String(this.downloadUrl || "").trim() && !this.useObsSdkDownload;
    },
    /** 下载直链：文档用原始文件地址，勿用文档预览 iframe 地址 */
    downloadUrl() {
      const rawPath = this.resource.filePath;
      if (!rawPath) {
        return "";
      }
      const ft = fileType(rawPath);
      if (ft === "document") {
        return getFullPath(rawPath);
      }
      if (ft === "video") {
        let p = rawPath.substring(0, rawPath.lastIndexOf(".")) + ".mp4";
        if (rawPath.indexOf("homework/") > -1) {
          p = rawPath.substring(0, rawPath.lastIndexOf(".")) + "_convert.mp4";
        }
        return getFullPath(p);
      }
      return getFullPath(rawPath);
    },
    /** 文案：下载（contentSize 自动换算为 B/KB/MB/GB）；缺省时占位为「—」 */
    downloadButtonText() {
      const raw = this.resource.contentSize;
      const sizeText =
        raw !== undefined && raw !== null && raw !== "" ? formatSize(raw) : "";
      const bracket = sizeText ? `（${sizeText}）` : "（—）";
      return this.$t("pages_components_resourcePreview_131", { var0: bracket });
    },
    fileType() {
      return fileType(this.resource.filePath);
    },
    filePath() {
      let path = this.resource.filePath;
      if (this.fileType == "document") {
        var src = DOCS_HOST + "?time=1";
        var location = getFullPath(path);
        if (location.indexOf("https://") != -1) {
          src += "&ssl=1";
        }
        location = encodeURIComponent(location);
        src += "&furl=" + location;
        path = src;
      } else if (this.fileType == "video") {
        path = path.substring(0, path.lastIndexOf(".")) + ".mp4";
        if (path.indexOf("homework/") > -1) {
          path = path.substring(0, path.lastIndexOf(".")) + "_convert.mp4";
        }
        path = getFullPath(path);
      } else {
        path = getFullPath(path);
      }
      return path;
    },
  },
  filters: {
    fullPath(input) {
      return getFullPath(input);
    },
  },
  data() {
    return {};
  },
  mounted() {
    if (this.fileType == "video") {
      this.player = new MediaElementPlayer("video-media", {
        success: (mediaElement) => {
          this.media = mediaElement;
          // this.map.set(this.media, {
          //   src: this.sourceUrl,
          //   currentTime: mediaElement.getCurrentTime()
          // })
        },
        error: (event) => {
          console.log(event.detail);
          setTimeout(() => {
            event.detail.target.parentElement.nextElementSibling
              .getElementsByClassName("mejs__cannotplay")[0]
              .getElementsByTagName("a")[0]
              .setAttribute("href", "javascript:;");
          }, 300);
        },
      });
      this.$once("hook:beforeDestroy", () => {
        const { player } = this;
        if (!player.paused) {
          player.pause();
        }
      });
    }
  },
  methods: {
    fileIcon,
    hide() {
      this.$emit("hide");
    },
    /** 下载保存文件名：尽量带上与存储一致的后缀 */
    getDownloadSaveName() {
      let name = (this.resource.fileName || "download").trim();
      const fp = (this.resource.filePath || "").split("?")[0];
      const dot = fp.lastIndexOf(".");
      const ext = dot >= 0 ? fp.slice(dot + 1).toLowerCase() : "";
      if (ext && name && !name.toLowerCase().endsWith(`.${ext}`)) {
        name = `${name}.${ext}`;
      }
      return name || `download.${ext || "bin"}`;
    },
    /** 先 GET /obs/downloadToken 再调 Obs.download（与教学资料等一致） */
    onObsDownloadClick() {
      const pathKey = this.obsDownloadPathKey;
      const fullUrl = this.downloadUrl;
      const saveName = this.getDownloadSaveName();
      if (!pathKey || !fullUrl) {
        this.$message({
          message: this.$t("pages_components_resourcePreview_132"),
          type: "warning",
        });
        return;
      }
      const obs = new Obs(
        setObsConfig({
          uptokenHost: API_HOST,
          authorization: this.token,
          obsHost: RESOURCE_SERVER_HOST,
        })
      );
      const loading = this.$loading({
        lock: true,
        text: this.$t("pages_components_resourcePreview_133"),
        background: "rgba(0, 0, 0, 0.35)",
      });
      getObsDownloadToken(pathKey)
        .then(() => {
          obs.download(fullUrl, saveName);
        })
        .catch((reason) => {
          const msg =
            reason && typeof reason.message === "string"
              ? reason.message
              : this.$t("pages_components_resourcePreview_134");
          this.$message({ message: msg, type: "error" });
        })
        .finally(() => {
          loading.close();
        });
    },
  },
  components: {
    AudioComponent,
  },
};
</script>

<style lang="scss" scoped>
.ul-resource-preview__wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 3000;
  .ul-resource-preview {
    height: 100%;
  }
}
.ul-resource__header {
  position: fixed;
  z-index: 3001;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 50px;
  padding: 10px 20px;
  background-color: rgba(0, 0, 0, 0.7);
  box-sizing: border-box;
  color: #fff;
}
.ul-resource__header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 30px;
  max-width: 1200px;
  margin: 0 auto;
}
.ul-resource__title-left {
  flex: 1;
  min-width: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ul-resource__header-actions {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}
.preview-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  padding: 0 14px;
  font-size: 14px;
  line-height: 1;
  color: #e85d4c;
  background: rgba(255, 236, 230, 0.95);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
  box-sizing: border-box;
}
.preview-action-btn:hover {
  opacity: 0.92;
}

.ul-page__header-right {
  float: right;
}
.ul-resource__body {
  padding: 70px 0 20px 0px;
  text-align: center;
  height: 100%;
}
.resource-image {
  img {
    max-width: 800px;
    max-height: 500px;
  }
}
.resource-document {
  iframe {
    width: 940px;
    height: calc(100vh - 130px);
    background: #fff;
  }
}
::v-deep.resource-video {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .video-wrapper {
    height: 450px;
    max-height: 450px;
    width: 800px;
    margin: 0 auto;
    .custom-video {
      height: 450px;
      max-height: 450px;
    }
    .mejs__container-fullscreen video {
      max-height: 100%;
    }
    .mejs__container {
      height: 450px;
      max-height: 450px;
    }
  }
}

.audio-wrapper {
  width: 280px;
  margin: 70px auto;
}

.resource-other {
  position: absolute;
  left: 50%;
  margin-left: -425px;
  margin-top: -240px;
  background-color: #fff;
  display: flex;
  width: 850px;
  height: 480px;
  top: 50%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  i {
    font-size: 80px;
    margin-bottom: 32px;
  }
  div {
    font-size: 16px;
  }
}

.mask-fade-enter-active {
  animation: mask-fade-in 0.3s;
}

.mask-fade-leave-active {
  animation: mask-fade-out 0.3s;
}

@keyframes mask-fade-in {
  0% {
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

@keyframes mask-fade-out {
  0% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
}
</style>